module.exports = __webpack_public_path__ + "img/share-icon.efc4f0a7.svg";